const parser = new DOMParser()

export const kolleginButtonPc: HTMLElement | null = parser.parseFromString(
    `
    <div class="col-xs-3 link-bar button-kollegin-link" style="display: block;">
        <a class="btn btn-block btn-default text-left" href="" rel="nofollow" target="_blank">
            <span class="icon kollegin-icon no-hover inline lower before-text icon-16">
                <svg class="icon-write-post" width="100" height="100" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" fill="red">
                  <path d="M2.652 5.702h1.392c0.304-1.7 0.969-3.282 2.199-4.343 1.103-0.952 2.461-1.359 3.923-1.359 1.2 0 2.376 0.13 3.359 0.53l-0.464 1.613c-0.826-0.395-1.818-0.508-2.851-0.508-0.981 0-1.915 0.279-2.663 0.939-0.376 0.331-0.707 0.755-0.995 1.271s-0.505 1.134-0.652 1.856h6.232l-0.376 1.459h-6.055c-0.034 0.372-0.022 0.825-0.022 1.204 0 0.096 0.007 0.21 0.022 0.343h5.613l-0.376 1.459h-5.083c0.499 2.606 1.987 4.199 4.641 4.199 0.996 0 2.016-0.226 2.807-0.707l0.442 1.436c-0.442 0.339-0.991 0.575-1.646 0.707s-1.315 0.199-1.978 0.199c-1.68 0-3.046-0.479-4.099-1.436s-1.727-2.424-2.022-4.398h-1.746l0.398-1.459h1.215c-0.035-0.315-0.022-0.798-0.022-1.127 0-0.118 0.007-0.258 0.022-0.42h-1.613l0.398-1.459z"></path>
                </svg>
            </span> Hier arbeiten
        </a>
        <span class="powered-by-kollegin">powered by Kollegin.de</span>
    </div>
`,
    "text/html",
).body.firstElementChild as HTMLElement | null

export const kolleginButtonMobile: HTMLElement | null = parser.parseFromString(
    `
    <div class="col-xs-12 link-bar button-kollegin-link" style="display: block;">
        <a class="btn btn-block btn-lg btn-kollegin text-left" href="" rel="nofollow" target="_blank">
            Hier arbeiten
        </a>
        <span class="powered-by-kollegin">powered by Kollegin.de</span>
    </div>
`,
    "text/html",
).body.firstElementChild as HTMLElement | null
